export default {
  SnakegameTitle: '詞彙貪食蛇設定',
  topic: '主題(即遊戲活動名稱)',
  inputTopic: '請輸入遊戲主題名稱',
  correctItems: '答對題目',
  correctItemsPlaceholder: '輸入正答詞彙，可用換行或逗號(,)分隔，按下Enter確認新增項目',
  errorItems: '答錯題目',
  errorItemsPlaceholder: '輸入錯誤詞彙，可用換行或逗號(,)分隔，按下Enter確認新增項目',
  difficulty: '難度等級',
  difficultyEasy: '簡單',
  difficultyMedium: '中等',
  difficultyHard: '困難',
  boardSize: '棋盤大小',
  snakeSpeed: '蛇移動速度',
  foodCount: '食物數量',
  items: '個',
  gameDuration: '遊戲時長',
  second: '秒',
  clearData: '清空資料',
  saveSettings: '儲存設定',
  wordExists: '此詞彙已存在',
  maxVocabulary: '正確詞彙數量已達上限 (20個)',
  maxErrorVocabulary: '錯誤詞彙數量已達上限 (20個)',
  dataCleared: '資料已清空',
  settingsSaved: '設定已儲存',
  pleaseCompleteSettings: '請完成所有必填項目（至少需要5個正確詞彙和5個錯誤詞彙）',
  unsubmittedWarning: '發現到輸入框尚有未按下Enter 的詞彙，請確認後再進行操作!',
  gamePaused: '活動暫停',
  gameOver: '遊戲結束',
  showAnswers: '查看答案',
  referenceAnswers: '參考答案',
  maxLength: '最長長度',
  leftPlayer: '左側玩家',
  rightPlayer: '右側玩家',
  sendSuccess: '遊戲資料已成功推送！',
  sendCooldown: '已按過送出，請等候1分鐘才可再操作',
  pushSuccess: '遊戲短網址已成功推送！',
  pushFailed: '推送失敗：{message}',
  tokenRefreshing: '正在刷新授權資訊，請稍後再試...',
};
